import { render, staticRenderFns } from "./CategoryIndex.vue?vue&type=template&id=7ec44aa2&"
import script from "./CategoryIndex.vue?vue&type=script&lang=js&"
export * from "./CategoryIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports